import { ReactComponent as ImageIcon } from 'assets/icons/imageFull.svg';
import LabeledDeliveryStatus from 'components/molecules/labeledStatus/LabeledDeliveryStatus';
import React, { ReactNode, useState } from 'react';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { IMusicProductDigitalDeliveryServiceResponse } from 'services/music-product-digital/types/query';
import './DeliveryCard.scss';
import { useTranslation } from 'react-i18next';

interface IDeliveryCardProp {
  service: IMusicProductDigitalDeliveryServiceResponse;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  size?: 'compact';
  highlighted?: boolean;
  customIcon?: ReactNode;
}

const DeliveryCard = ({
  service,
  size,
  onClick,
  highlighted,
  customIcon,
}: IDeliveryCardProp) => {
  const [imageError, setImageError] = useState(false);
  const {t} = useTranslation()
  return (
    <div
      onClick={onClick}
      className={`delivery-card-wrapper ${size ?? ''} ${
        highlighted ? 'highlighted' : ''
      } ${DELIVERY_STATUS[service.deliveryStatus]}`}>
      <div className='delivery-card-image'>
        {customIcon ??
          (service.logoImageUrl && !imageError ? (
            <img
              src={service.logoImageUrl}
              alt='imagee'
              onError={e => {
                e.currentTarget.onerror = null;
                setImageError(true);
              }}
            />
          ) : (
            <ImageIcon
              height={50}
              width={50}
              style={{ fill: 'var(--text)', opacity: 0.3 }}
            />
          ))}
      </div>

      <div className='delivery-card'>
        <div className='delivery-card-header'>
          <div className='delivery-card-title'>{service.salesChannelName}</div>
          <div className='delivery-card-description'>
            {t(`enum.DELIVERY_STATUS.${DELIVERY_STATUS[service.deliveryStatus]}`)}
            {/* {service.providerName} */}
          </div>
        </div>
        <LabeledDeliveryStatus status={service.deliveryStatus} noname />
      </div>
    </div>
  );
};

export default DeliveryCard;

const deliveryStatusProgress = [
  DELIVERY_STATUS.waitingForAccept,
  DELIVERY_STATUS.waiting,
  DELIVERY_STATUS.inProgress,
  DELIVERY_STATUS.waitingForACKFile,
  DELIVERY_STATUS.inProgressProcessingACKFile,
  DELIVERY_STATUS.waitingForAssetIds,
  DELIVERY_STATUS.inProgressAssigningAssetIds,
  DELIVERY_STATUS.publishWaiting,
  999,
];
